import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldEditorMapPopupComponent } from './field-editor-map-popup.component';
import {DxTabsModule} from 'devextreme-angular';



@NgModule({
  declarations: [FieldEditorMapPopupComponent],
    imports: [
        CommonModule,
        DxTabsModule
    ],
  exports: [FieldEditorMapPopupComponent]
})
export class FieldEditorMapPopupModule { }
